class UserLocationApi {
  constructor() {
    this.ipCountry = null
    this.connectionIp = null
  }

  setIpCountry(ipCountry) {
    this.ipCountry = ipCountry
  }

  setConnectionIP(connectionIp) {
    this.connectionIp = connectionIp
  }

  isEmpty() {
    return !this.ipCountry || !this.connectionIp
  }
}

const userLocationApi = new UserLocationApi()

export default userLocationApi
